import React from 'react'
import FooterNew from '../components/Footer'
import { Container } from 'react-bootstrap'
import './termsandservices.scss'
import { useTranslation } from 'react-i18next'

const Impressum = () => {
  const { t } = useTranslation()
  return (
    <>
      <Container>
        <h1 className='text-center pt-5 pricing-header-1'>{t('impress.title')}</h1>
        <div className='text-center pt-5 tns-increase-height'>
          <h3 className='tns-header-1'>{t('impress.management')}</h3>
          <p className='p-0 m-0'>CrossLab GmbH </p>
          <p className='p-0 m-0'>Hardwaldstrasse 12</p>
          <p className='p-0 mt-0'>8951 Fahrweid</p>
          <h3 className='tns-header-1'>{t('impress.email')}</h3>
          <p>contact@crosslab.ch</p>
          <h3 className='tns-header-1'>{t('impress.details_title')}</h3>
          <p>{t('impress.details_description')}</p>
        </div>
      </Container>
      <FooterNew />
    </>
  )
}

export default Impressum
